module.exports = "/_next/static/images/partner-guarda-3232a3c7ea54f3da5e46e1fa23222084.svg";